import React from 'react';
import '../styles/TeamLabelCalendar.css';

export default function EmployeeColumnHeader({ name, count, className = '', style }) {
  return (
    <div className={`team-cal-v3__col-head ${className}`.trim()} style={style}>
      <span className="team-cal-v3__col-head-name">{name}</span>
      {count > 0 ? (
        <span className="team-cal-v3__col-head-badge" title="Appointments today">
          {count}
        </span>
      ) : null}
    </div>
  );
}
